import Reveal from '@/components/common/Reveal';

const rows = [
  {
    n: '01',
    k: 'Handwritten, not templated',
    v: 'Every clinic gets its own layout, its own typography choices, its own build. No Wix, no Webflow-in-a-hurry, no page builders.',
  },
  {
    n: '02',
    k: 'Frontend performance is the KPI',
    v: 'We optimise Core Web Vitals before we optimise anything else. Fast on the phones your patients actually use.',
  },
  {
    n: '03',
    k: 'Copy is a design decision',
    v: 'We direct writing the same way we direct spacing. No stock phrases about excellence, innovation or synergy.',
  },
  {
    n: '04',
    k: 'Small team, senior hands',
    v: 'The person you speak with is the same person who designs and builds your website.'  },
  {
    n: '05',
    k: 'Honest scope, honest calendar',
    v: 'Five weeks means five weeks. Timelines are what we protect first, because a launch delayed is trust spent.',
  },
];

export const WhyTechsFlow = () => (
  <section className="py-24 md:py-32 bg-ink text-paper">
    <div className="mx-auto container-editorial">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-14">
        <Reveal className="lg:col-span-7">
          <div className="label-eyebrow mb-4 text-paper/60">Chapter — Why TechsFlow</div>
          <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-balance text-paper">
            Five ways this <span className="italic-serif text-paper/60 text-sienna">will feel different.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-5 lg:pt-6">
          <p className="text-base md:text-lg text-paper/70 leading-relaxed">
            Most agency work reads the same. Ours is written to read like your
            clinic's neighbour, not a national brand. These are the promises
            behind that difference.
          </p>
        </Reveal>
      </div>

      <ul className="border-t border-paper/25">
        {rows.map((r, i) => (
          <Reveal key={r.n} delay={i * 0.06}>
            <li className="grid grid-cols-12 gap-4 md:gap-8 py-7 md:py-9 border-b border-paper/25 hover:bg-paper/[0.06] transition-colors -mx-5 md:-mx-10 px-5 md:px-10">
              <span className="hidden md:block md:col-span-1 font-mono text-xs text-paper/50 rule-numeric">{r.n}</span>
              <h3 className="col-span-12 md:col-span-4 font-serif text-2xl md:text-3xl tracking-tight text-paper">
                {r.k}
              </h3>
              <p className="col-span-12 md:col-span-12 lg:col-span-7 mt-2 md:mt-3 lg:mt-0 text-sm md:text-base text-paper/70 leading-relaxed max-w-2xl">
                {r.v}
              </p>
            </li>
          </Reveal>
        ))}
      </ul>
    </div>
  </section>
);

export default WhyTechsFlow;
